import { NumberInputViewModel, ValueFormField } from '@sitecore-jss/sitecore-jss-forms';
import { ValueFieldProps, Label, FieldChangeCallback } from '@sitecore-jss/sitecore-jss-react-forms';
import { FC, Fragment } from 'react';

import { FieldValidationErrors } from '../CustomFields/FieldValidationErrors';
import { getFormFieldAriaProps } from '../Functions/FormFieldAriaProps';

/**
 * Overrides the built-in Sitecore forms number.
 * @see [Original Number Implementation](https://github.com/Sitecore/jss/blob/v22.10.0/packages/sitecore-jss-react-forms/src/components/field-templates/number.tsx)
 *
 * Markup and functionality should be 1:1 with the exception of `getFormFieldAriaProps`.
 *
 * @param props - Number properties.
 * @returns A number field.
 */
export const BaseNumber: FC<ValueFieldProps<NumberInputViewModel>> = (props) => {
  const { errors, field, onChange, tracker, value } = props;

  return (
    <Fragment>
      <Label {...props} />
      <input
        type="number"
        className={field.model.cssClass}
        id={field.valueField.id}
        name={field.valueField.name}
        value={value}
        step={field.model.step}
        min={field.model.min}
        max={field.model.max}
        onChange={(e) => handleOnChange(field, e.target.value, onChange)}
        onFocus={() => tracker.onFocusField(field, value)}
        onBlur={() => tracker.onBlurField(field, value, errors)}
        {...getFormFieldAriaProps(field, errors)}
      />
      <FieldValidationErrors {...props} />
    </Fragment>
  );
};

function handleOnChange(field: ValueFormField, fieldValue: string, callback: FieldChangeCallback) {
  const errorMessages = [];
  let valid = true;

  if (field.model.required && !fieldValue) {
    errorMessages.push(`${field.model.title} is required`);
    valid = false;
  }

  callback(field.valueField.name, fieldValue, valid, errorMessages);
}
